module.exports = __webpack_public_path__ + "static/media/SierFemale.28a50ee8.svg";